window.addEventListener('DOMContentLoaded', function(e) {
    let load_button = document.querySelector('.market-page-content .btn.load-more');
    if (load_button) {
        load_button.addEventListener('click', (e) => {
            e.preventDefault();
            let to_show = document.querySelectorAll('.projects-container .project:not(.active)');
            for (let i = 0 ; i < 16 ; i++) {
                if (to_show[i]) {
                    to_show[i].classList.add('active');
                }
            }
            if (to_show.length <= 16) {
                load_button.classList.remove('show');
            }
        })
    }
})